import { Track, TrackSource } from '../../domain/track/Track';
import { TrackDTO } from '../../domain/track/TrackDTO';

export class TrackMapper {
  static toDomain(raw: TrackDTO): Track {
    const { id, driver_id, project_id, vehicle_id, lat, lng, source, created_at } = raw;

    return Track.create(
      {
        driver_id,
        vehicle_id,
        project_id,
        lat,
        lng,
        source: source as TrackSource | undefined,
        created_at,
      },
      id
    );
  }

  static toDTO(track: Track): TrackDTO {
    const { id, driver_id, vehicle_id, project_id, lat, lng, source, created_at } = track;

    return { id, driver_id, vehicle_id, project_id, lat, lng, source, created_at };
  }
}
